import { Controller } from '@hotwired/stimulus';

// Keeps the scroll position across a Turbo Frame navigation promoted to a visit
// (data-turbo-action="advance"). The layout scrolls inside #page, not the window, and such a
// visit fires turbo:load, where app.js mounts a new Vue root on #page: the element is replaced
// and the new one starts back at the top. app.js registers its turbo:load listener first, so
// the one added here runs after Vue has mounted the new #page.
export default class extends Controller {
  remember() {
    const scroller = document.getElementById('page');
    if (!scroller) return;

    const top = scroller.scrollTop;
    document.addEventListener(
      'turbo:load',
      () => {
        const page = document.getElementById('page');
        if (page) page.scrollTop = top;
      },
      { once: true }
    );
  }
}
